
import type { BaseErrorResponse, GetProfileFieldValueChangesRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useChangeLog() {
  class ChangeLog<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Change log
     * @name ChangeLogProfileFieldValueControllerGetProfileFieldValueChanges
     * @summary Getting a list of profile-field-value changes
     * @request GET:/api3/change-log/profile-field-value
     * @response `200` `GetProfileFieldValueChangesRes`
     * @response `400` `BaseErrorResponse`
     */
    changeLogProfileFieldValueControllerGetProfileFieldValueChanges = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /** @example 1 */
        accountId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetProfileFieldValueChangesRes, BaseErrorResponse>({
        path: '/api3/change-log/profile-field-value',
        method: 'GET',
        query,
        format: 'json',
        ...params,
      });
  }

  return new ChangeLog();
}
